import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  // Grid, // Unused
  // Slider, // Unused
  // FormControl, // Unused
  // InputLabel, // Unused
  // Select, // Unused
  // MenuItem, // Unused
  // FormControlLabel, // Unused
  // Checkbox, // Unused
  // Divider, // Unused
} from '@mui/material';
import { useThemeColors } from '../theme/useThemeColors';

interface LimiterSettingsDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (settings: { 
    gain: number;
  }) => void;
  initialSettings: { 
    gain: number;
  };
}

export const LimiterSettingsDialog: React.FC<LimiterSettingsDialogProps> = ({
  open,
  onClose,
  onSave,
  initialSettings,
}) => {
  const { themeColor, themeHoverColor } = useThemeColors();
  const [settings, setSettings] = useState(initialSettings);
  const [gainInputValue, setGainInputValue] = useState(initialSettings.gain.toString());

  // Update input value when initialSettings change
  useEffect(() => {
    setSettings(initialSettings);
    setGainInputValue(initialSettings.gain.toString());
  }, [initialSettings]);

  const handleSave = () => {
    // Parse the final value when saving
    const finalGain = parseFloat(gainInputValue) || 0;
    onSave({ gain: finalGain });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Global Gain Settings</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Adjust the global gain for all audio processed in the VO Manager.
          </Typography>
          
          {/* Gain control */}
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Global Gain
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                label="Gain (dB)"
                type="number"
                value={gainInputValue}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  
                  // Update the input value immediately for display
                  setGainInputValue(inputValue);
                  
                  // Only update the settings if it's a valid number
                  const newGain = parseFloat(inputValue);
                  if (!isNaN(newGain)) {
                    setSettings({ ...settings, gain: newGain });
                  }
                }}
                inputProps={{
                  step: 0.1,
                  min: -24, // Expanded range for gain
                  max: 24,  // Expanded range for gain
                }}
                fullWidth
                helperText="Adjust overall volume. Positive values amplify, negative values attenuate."
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: '#000000' }}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{
            backgroundColor: themeColor,
            color: '#000000',
            '&:hover': {
              backgroundColor: themeHoverColor,
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 